import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, nextTick, onBeforeUnmount, onMounted, ref, watch } from 'vue';
import { useUserStore } from '../useUserStore';
import { storeToRefs } from 'pinia';
import MultipleSelectInput from '@/corePagesModule/SelectInput/MultipleSelectInput.vue';
import { i18n } from '@/i18n';
import { FilterInfoState } from '@/corePagesModule/SelectInput/interface/uiState';
import { isNone, isSuccess } from '@/coreDomainsModule/uiLoadingState';
import { UserAccountService } from '@/coreDomainsModule/services/userAccountService';

export default /*@__PURE__*/_defineComponent({
  __name: 'MultipleUserSelectInput',
  props: {
    selectInputIndex: {},
    label: { default: undefined },
    placeholder: { default: undefined },
    originalSelectedUserIdList: { default: undefined }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const t = i18n.t;
const store = useUserStore();
const { state } = storeToRefs(store);
const { $reset, init, fetchUserList } = store;
const props = __props;
const emits = __emit;
const didOpen = ref(false);
/**
 * fetchの状態を変更する関数
 * SelectInputを開いたり閉じたりするとstateがリセットされてしまうので、ここで書き換えて更新をかけている
 */
const switchFetchState = () => {
  state.value.searchingUserList = state.value.userList;
  if (state.value.userList.length > 0 && didOpen.value) {
    if (isSuccess(state.value.userListFetchState.status)) {
      state.value.userListFetchState.status = { type: 'none' };
    } else if (isNone(state.value.userListFetchState.status)) {
      state.value.userListFetchState.status = { type: 'success' };
    }
  } else {
    didOpen.value = true;
  }
};
onMounted(async () => {
  await init();
  nextTick(() => {
    state.value.selectedUserList = confirmedOriginalSelectedUserIdList.value;
  });
});
onBeforeUnmount(() => {
  $reset();
});
watch(
  () => props.originalSelectedUserIdList,
  () => {
    nextTick(() => {
      state.value.selectedUserList = confirmedOriginalSelectedUserIdList.value;
    });
  }
);
const userNameList = computed(() => state.value.userList.map((user) => UserAccountService.getDisplayName(user) ?? ''));
const searchedUserNameList = computed(() => state.value.searchingUserList.map((user) => UserAccountService.getDisplayName(user) ?? ''));
const selectedUserNameList = computed(() => state.value.selectedUserList.map((user) => UserAccountService.getDisplayName(user) ?? ''));
const label = computed(() => props.label ?? t('担当者'));
const placeholder = computed(() => props.placeholder ?? t('担当者'));
const selectedIndexes = computed((): number[] => {
  return userNameList.value.reduce((acc, userName, index) => {
    if (selectedUserNameList.value.includes(userName)) {
      acc.push(index);
    }
    return acc;
  }, [] as number[]);
});
const confirmedOriginalSelectedUserIdList = computed(() => {
  return props.originalSelectedUserIdList && props.originalSelectedUserIdList.length > 0
    ? props.originalSelectedUserIdList
        .map((userId) => {
          const userData = state.value.userList.find((user) => user.email === userId);
          if (!userData) {
            console.error('ユーザーが見つかりません', userId);
            return undefined;
          }
          return userData;
        })
        .filter((userData) => userData !== undefined)
    : [];
});
/**
 * SelectInputの値が更新された際のハンドラ
 * @param value - 選択されたユーザー名リスト
 */
const onUpdate = (value: string[]) => {
  const selectedUserList = state.value.userList.filter((user) => value.includes(UserAccountService.getDisplayName(user)));
  const selectedUserIdList = selectedUserList.map((user) => {
    if (user.email === undefined) {
      console.error('IDのないユーザー情報が存在します', user);
      throw new Error('IDのないユーザー情報が存在します');
    }
    return user.email;
  });
  state.value.selectedUserList = selectedUserList;
  emits('update:modelValue', selectedUserIdList);
};
/**
 * キーワード
 * @param keyword - キーワード
 */
const onSearch = async (keyword: string) => {
  await fetchUserList(keyword);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(MultipleSelectInput, {
    index: _ctx.selectInputIndex,
    "selected-list": selectedUserNameList.value,
    placeholder: placeholder.value,
    label: label.value,
    "filter-type": "USER",
    "prop-options": userNameList.value,
    "prop-filtered-options": searchedUserNameList.value,
    "prop-paging-state": (_unref(state).userListFetchState.status as FilterInfoState),
    "prop-selected-indexes": selectedIndexes.value,
    "use-reset": false,
    "use-teleport": "",
    "onClick:selectInput": switchFetchState,
    "onUpdate:modelValue": onUpdate,
    onClose: switchFetchState,
    onSearch: onSearch
  }, null, 8, ["index", "selected-list", "placeholder", "label", "prop-options", "prop-filtered-options", "prop-paging-state", "prop-selected-indexes"]))
}
}

})